import restCrudActions from "../../../np-crud/store/restCrudActions";
import { getAxiosInstance } from "../../../np-rest/rest";
import * as actionTypes from "./actionTypes";
import config from '../../../../config/config';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from "../../../../index";
import { getUserSetting } from "../../../../store";
import { GET_TRANSLATIONS } from "../../../../redis-constants";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: "translations",
    pluginName: "TRANSLATE",
    entityName: "TRANSLATE",
    fetchSuccessMessage: "",
    loadSuccessMessage: ""
});

// Fetch Translation action creators
export const fetchTranslationInit = () => {
    return crudActions.fetchInit();
};
export const fetchTranslationStart = () => {
    return crudActions.fetchStart();
};
export const fetchTranslationSuccess = (fetchTranslationCount, listTranslationCount) => {
    return crudActions.fetchSuccess(fetchTranslationCount, listTranslationCount);
};
export const fetchTranslationFail = () => {
    return crudActions.fetchFail();
};

export const fetchTranslationsCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchTranslationStart());
        try {
            let countRes = await rest.post("translations/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchTranslationSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchTranslationFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch translation."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchTranslationFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch translation."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchTranslations = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchTranslationStart());
        try {
            let listRes = await rest.post("translations/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchTranslationSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchTranslationFail());
            return []

        } catch (error) {
            dispatch(fetchTranslationFail());
            return []
        }
    }
}

// Create Translations  action creators

// Create translations action creators
export const createTranslationsInit = () => {
    return crudActions.createInit();
};
export const createTranslationsStart = () => {
    return crudActions.createStart();
};
export const createTranslationsSuccess = createdTranslations => {
    return crudActions.createSuccess(createdTranslations);
};
export const createTranslationsFail = error => {
    return crudActions.createFail(error);
};
export const createTranslations = params => {
    let userSettings = getUserSetting();
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTranslationsStart());
        try {
            let res = await rest.post('/translations/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createTranslationsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created translations.`,
                    options: {
                        variant: 'success'
                    }
                });
                socket.emit(GET_TRANSLATIONS, { LanguageKey: userSettings?.DefaultLanguage || 'en' });
                return res.data.result.data;
            }
            dispatch(createTranslationsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create translations."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create translations."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTranslationsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit translations action creators
export const editTranslationsInit = () => {
    return crudActions.editInit();
};
export const editTranslationsStart = () => {
    return crudActions.editStart();
};
export const editTranslationsSuccess = editedTranslations => {
    return crudActions.editSuccess(editedTranslations);
};
export const editTranslationsFail = error => {
    return crudActions.editFail(error);
};

export const editTranslations = params => {
    let userSettings = getUserSetting();

    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editTranslationsStart());
        try {
            let res = await rest.post('/translations/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editTranslationsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated translations.`,
                    options: {
                        variant: 'success'
                    }
                });
                socket.emit(GET_TRANSLATIONS, { LanguageKey: userSettings?.DefaultLanguage || 'en' });
                return res.data.result.data;
            }
            dispatch(editTranslationsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit translations."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create translations."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editTranslationsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Delete Translate  action creators
export const deleteTranslationInit = () => {
    return crudActions.deleteInit();
};
export const deleteTranslationStart = () => {
    return crudActions.deleteStart();
};
export const deleteTranslationSuccess = deletedTranslation => {
    return crudActions.deleteSuccess(deletedTranslation);
};
export const deleteTranslationFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteTranslation = deleteData => {
    let userSettings = getUserSetting();
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
        socket.emit(GET_TRANSLATIONS, { LanguageKey: userSettings?.DefaultLanguage || 'en' });
    };
};



// Load translate action creators
export const loadTranslationInit = () => {
    return crudActions.loadInit();
};
export const loadTranslationStart = () => {
    return crudActions.loadStart();
};
export const loadTranslationSuccess = loadedTranslation => {
    return crudActions.loadSuccess(loadedTranslation);
};
export const loadTranslationFail = error => {
    return crudActions.loadFail(error);
};
export const loadTranslation = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const fetchCustomers = () => {
    let userSettings = getUserSetting();

    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/customers/list", { listAll: true });
            if (res.data && res.data.succeeded) {
                let customers = [];

                for (var cs of res.data.result.data) {
                    customers.push({ value: cs.CustomerID, displayValue: `${cs.Name}` });
                }
                socket.emit(GET_TRANSLATIONS, { LanguageKey: userSettings?.DefaultLanguage || 'en' });
                return customers;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list delivery notes  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const setDefaultLanguage = lang => {
    return {
        type: actionTypes.SET_DEFAULT_TRANSLATION,
        DefaultLanguage: lang
    };
};
export const exportTranslate = (customerID) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/translations/export?ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            if (response.status === 200) {
                return response.blob();
            }
            return null;
        });
    }
}
export const uploadTranslationsStart = () => {
    return {
        type: 'UPLOAD_TRANSLATIONS_START',
    };
};
export const uploadTranslationsSuccess = () => {
    return {
        type: 'UPLOAD_TRANSLATIONS_SUCCESS',
    };
};
export const uploadTranslationsFail = () => {
    return {
        type: 'UPLOAD_TRANSLATIONS_FAIL',
    };
};


export const uploadProgress = (data) => {
    return {
        type: 'TRANSLATE|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};


export const uploadTranslations = data => {
    const rest = getAxiosInstance();
    let userSettings = getUserSetting();

    return async dispatch => {
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }))
                }
            }
            dispatch(uploadTranslationsStart())
            let res = await rest.post('translations/import', data, config);
            if (res.data.status === 200) {
                dispatch(uploadTranslationsSuccess())
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                dispatch(uploadProgress({ progress: 100, loadSize: 0, maxSize: 0, snackStart: false }));

                socket.emit(GET_TRANSLATIONS, { LanguageKey: userSettings?.DefaultLanguage || 'en' });

                return res.data.status === 200;
            }
            else {
                dispatch(uploadTranslationsFail());
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list delivery notes  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            dispatch(uploadTranslationsFail());
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}
